import { render, staticRenderFns } from "./PostCostWorkOrders.vue?vue&type=template&id=56d9112e&"
import script from "./PostCostWorkOrders.vue?vue&type=script&lang=js&"
export * from "./PostCostWorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./PostCostWorkOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports